import type { JobContractSearchRequest } from '@trukt/tms-api/JobService';
import { createKey } from '../../createKey';

const keyHandler = createKey('job-contract');

export const JobContractServiceKeys = {
  key: keyHandler.key,
  search: keyHandler.createMethod<JobContractSearchRequest>(),
};
